module.exports = __webpack_public_path__ + "static/media/34DSS12.87d16895.jpg";